import React, { useEffect, useState } from 'react';
import ProductSearchUI from '../../../components/commonComponents/ProductSearchUI';
import withNotify from '../../../common/withNotify';
import withOnline from '../../../common/withOnline';
import withLoader from '../../../common/withLoader';
import {
  getCasesProducts,
  initAPIController
} from '../../../utils/utils';
import { sortData } from '../../../common/globals';
// import Bugsnag from '../../../helpers/bugsnag';

function SearchByProduct({
  notify, online, setLoader, loader, onProductSelect, selectedProductNumbers
}) {
  const [searchNumber, setSearchNumber] = useState('');
  const [searchDescription, setSearchDescription] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const [reachedLastPage, setReachedLastPage] = useState(false);
  const [apiController, setApiController] = useState();
  const pageSize = 20;

  const [products, setProducts] = useState([]);

  useEffect(() => {
    try {
      const initialPage = 1;
      setPageNumber(initialPage);
      setReachedLastPage(false);
      if (!searchNumber.length && !searchDescription.length) {
        setProducts([]);
        return;
      }
      if (searchNumber.length < 3 && searchDescription.length < 3) return;
      getSearchedProducts(searchNumber, searchDescription, initialPage).then((productsResult) => {
        setProducts(productsResult);
      });
    } catch (e) {
      // Bugsnag.notify(e);
    }
  }, [searchNumber, searchDescription]);

  useEffect(() => {
    try {
      if ((searchNumber.length < 3 && searchDescription.length < 3)
        || pageNumber === 1
        || reachedLastPage) return;
      getSearchedProducts(searchNumber, searchDescription, pageNumber).then((newProducts) => {
        if (typeof newProducts !== 'undefined' && newProducts.length < pageSize) {
          setReachedLastPage(true);
        }
        if (typeof newProducts !== 'undefined') {
          setProducts((lastProducts) => [...lastProducts, ...newProducts]);
        }
      });
    } catch (e) {
      // Bugsnag.notify(e);
    }
  }, [pageNumber]);

  const onNextPage = () => {
    if (!loader && !reachedLastPage) {
      setPageNumber((number) => number + 1);
    }
  };

  const getSearchedProducts = async (
    localSearchNumber,
    localSearchDescription,
    localPageNumber,
  ) => {
    try {
      if (!online) {
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 5
        });
        return [];
      }

      if (apiController) apiController.abort();
      setApiController(initAPIController());
      const searchData = {};
      if (searchNumber) searchData.productNo = localSearchNumber;
      if (searchDescription) searchData.productDescription = localSearchDescription;
      searchData.page = localPageNumber;
      searchData.size = pageSize;
      setLoader(true);
      const searchResponse = await getCasesProducts(searchData);
      // console.log(searchResponse);
      if (searchResponse.status) {
        const responseProducts = searchResponse?.data ? searchResponse.data : [];
        setLoader(false);
        sortData(responseProducts, 'ProductNo');
        return responseProducts.map((product) => ({
          number: product.ProductNo,
          description: product.ProductDescription
        }));
      }
      setLoader(false);
      // if (!searchResponse) return [];
      // const responseProducts = searchResponse?.data ? searchResponse.data : [];
      // setLoader(false);
      // sortData(responseProducts, 'ProductNo');
      // return responseProducts.map((product) => ({
      //   number: product.ProductNo,
      //   description: product.ProductDescription
      // }));
    } catch (e) {
      // Bugsnag.notify(e);
    }
  };

  return (
    <ProductSearchUI
      setProductDescription={setSearchDescription}
      onProductSelect={onProductSelect}
      selectedProductsNumbers={selectedProductNumbers}
      productNumber={searchNumber}
      setProductNumber={setSearchNumber}
      productDescription={searchDescription}
      products={products}
      onLastItemReached={onNextPage}
      productsLoading={loader}
      focusProductNumber
    />
  );
}

export default withNotify(
  withOnline(
    withLoader(
      SearchByProduct
    )
  )
);
